export const getErrorMessage = (message) => {
  if (typeof message === 'string') {
    return message;
  }
  if (message && typeof message === 'object') {
    return message.message || 'Failed due to internal error';
  }
  return 'Failed due to internal error';
};